import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_TRIALINSTITUTION_LOAD_BY_ID,
    ACTION_TRIALINSTITUTIONS_LOAD_BY_TRIAL_ID,
    ACTION_TRIALINSTITUTIONS_LOAD_BY_INSTITUTION_ID,
    ACTION_TRIALINSTITUTION_LOAD_FAILURE,
    ACTION_TRIALINSTITUTION_LOAD_SUCCESS,

    ACTION_TRIALINSTITUTION_SAVE,
    ACTION_TRIALINSTITUTION_SAVE_SUCCESS,
    ACTION_TRIALINSTITUTION_SAVE_FAILURE,

    ACTION_TRIALINSTITUTION_CREATE,
    ACTION_TRIALINSTITUTION_CREATE_SUCCESS,
    ACTION_TRIALINSTITUTION_CREATE_FAILURE,

    ACTION_TRIALINSTITUTION_VALIDATE,
    ACTION_TRIALINSTITUTION_VALIDATE_SUCCESS,
    ACTION_TRIALINSTITUTION_VALIDATE_FAILURE,

    ACTION_TRIALINSTITUTION_CLEAR,
    ACTION_TRIALINSTITUTION_FILTER,

    TrialInstitutionAction,
} from '../actions/trialInstitution';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface ITrialInstitutionState {
    formData: Dtos.TrialInstitution | Dtos.TrialInstitution[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    saveState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    validateState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.TrialInstitution[];
    formLength: number;
}

const initialState: ITrialInstitutionState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    validateState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: [],
    formLength: 0
};


function loading(state: ITrialInstitutionState, _isLoading: boolean): ITrialInstitutionState {
    const newState: ITrialInstitutionState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(
    state: ITrialInstitutionState,
    formData: Dtos.TrialInstitution | Dtos.TrialInstitution[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionState {
    const newState: ITrialInstitutionState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function loadFailure(state: ITrialInstitutionState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionState {
    const newState: ITrialInstitutionState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function filter(state: ITrialInstitutionState, formFilter: IFormFilter): ITrialInstitutionState {

    const items: Dtos.TrialInstitution[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formLength = items ? items.length : 0;

    const formFilteredData = items ? items.filter(p => (p.active == true || formFilter.showInActive) &&
        (formFilter.search == "" ||
            p.display.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1) ||
            p.institutionDisplay.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1) : undefined;

    const newState: ITrialInstitutionState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        },
        formLength: {
            $set: formLength
        }
    });

    return newState;
}

function clear(state: ITrialInstitutionState, propertiesToClear?: string[]): ITrialInstitutionState {

    if (!propertiesToClear) {
        const newState: ITrialInstitutionState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: ITrialInstitutionState, _isSaving: boolean): ITrialInstitutionState {
    const newState: ITrialInstitutionState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: ITrialInstitutionState,
    formData: Dtos.TrialInstitution | Dtos.TrialInstitution[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionState {
    const newState: ITrialInstitutionState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: ITrialInstitutionState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionState {
    const newState: ITrialInstitutionState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: ITrialInstitutionState, _isCreating: boolean): ITrialInstitutionState {
    const newState: ITrialInstitutionState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: ITrialInstitutionState,
    formData: Dtos.TrialInstitution,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): ITrialInstitutionState {
    const newState: ITrialInstitutionState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: ITrialInstitutionState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionState {
    const newState: ITrialInstitutionState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function validating(state: ITrialInstitutionState, _isValidating: boolean): ITrialInstitutionState {
    const newState: ITrialInstitutionState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function validateSuccess(
    state: ITrialInstitutionState,
    formData: Dtos.TrialInstitution,
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionState {
    const newState: ITrialInstitutionState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        validateState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function validateFailure(state: ITrialInstitutionState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionState {
    const newState: ITrialInstitutionState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}


const TrialInstitutionReducer: Reducer<ITrialInstitutionState> = (state: ITrialInstitutionState = initialState, action: TrialInstitutionAction) => {
    switch (action.type) {
        case ACTION_TRIALINSTITUTION_LOAD_BY_ID:
        case ACTION_TRIALINSTITUTIONS_LOAD_BY_TRIAL_ID:
        case ACTION_TRIALINSTITUTIONS_LOAD_BY_INSTITUTION_ID:
            return loading(state, true);
        case ACTION_TRIALINSTITUTION_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_TRIALINSTITUTION_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTION_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_TRIALINSTITUTION_SAVE:
            return saving(state, true);
        case ACTION_TRIALINSTITUTION_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALINSTITUTION_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTION_CREATE:
            return creating(state, true);
        case ACTION_TRIALINSTITUTION_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_TRIALINSTITUTION_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTION_VALIDATE:
            return validating(state, true);
        case ACTION_TRIALINSTITUTION_VALIDATE_SUCCESS:
            return validateSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALINSTITUTION_VALIDATE_FAILURE:
            return validateFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTION_FILTER:
            return filter(state, action.formFilter);

    }

    return state;
}

export default TrialInstitutionReducer;